<template>

<div class="table-wrapper">

    <table class="report-table">

        <thead>

            <tr>

                <th rowspan="2">
                    公司
                </th>

                <th colspan="3">
                    0-1万
                </th>

                <th colspan="3">
                    1-3万
                </th>

                <th colspan="3">
                    3-5万
                </th>

                <th colspan="3">
                    5-10万
                </th>

                <th colspan="3">
                    10-20万
                </th>

                <th colspan="3">
                    20万以上
                </th>

                <th colspan="2">
                    合计
                </th>

            </tr>

            <tr>

                <th>人数</th>
                <th>业绩</th>
                <th>业绩占比</th>

                <th>人数</th>
                <th>业绩</th>
                <th>业绩占比</th>

                <th>人数</th>
                <th>业绩</th>
                <th>业绩占比</th>

                <th>人数</th>
                <th>业绩</th>
                <th>业绩占比</th>

                <th>人数</th>
                <th>业绩</th>
                <th>业绩占比</th>

                <th>人数</th>
                <th>业绩</th>
                <th>业绩占比</th>

                <th>人数</th>
                <th>业绩</th>

            </tr>

        </thead>

        <tbody>

            <tr
                v-for="item in data"
                :key="item.companyName"
                :class="{
                    summary:
                    item.companyName === '总计'
                }"
            >

                <td>
                    {{ item.companyName }}
                </td>

                <td>{{ item.r0_1.count }}</td>
                <td>{{ formatMoney(item.r0_1.amount) }}</td>
                <td>{{ item.r0_1.rate }}</td>

                <td>{{ item.r1_3.count }}</td>
                <td>{{ formatMoney(item.r1_3.amount) }}</td>
                <td>{{ item.r1_3.rate }}</td>

                <td>{{ item.r3_5.count }}</td>
                <td>{{ formatMoney(item.r3_5.amount) }}</td>
                <td>{{ item.r3_5.rate }}</td>

                <td>{{ item.r5_10.count }}</td>
                <td>{{ formatMoney(item.r5_10.amount) }}</td>
                <td>{{ item.r5_10.rate }}</td>

                <td>{{ item.r10_20.count }}</td>
                <td>{{ formatMoney(item.r10_20.amount) }}</td>
                <td>{{ item.r10_20.rate }}</td>

                <td>{{ item.gt20.count }}</td>
                <td>{{ formatMoney(item.gt20.amount) }}</td>
                <td>{{ item.gt20.rate }}</td>

                <td>{{ item.total.count }}</td>
                <td>{{ formatMoney(item.total.amount) }}</td>

            </tr>

        </tbody>

    </table>

</div>

</template>

<script>

export default {

    props:{

        data:{
            type:Array,
            default:()=>[]
        }

    },

    methods:{

        formatMoney(value){

            return Number(
                value || 0
            ).toLocaleString()

        }

    }

}

</script>

<style scoped>

.table-wrapper{

    overflow-x:auto;

}

.report-table{

    border-collapse:collapse;

    width:100%;

    min-width:1800px;

}

.report-table th{

    background:#c00000;

    color:#fff;

    border:1px solid #ddd;

    padding:10px;

    text-align:center;

}

.report-table td{

    border:1px solid #ddd;

    padding:8px;

    text-align:center;

}

.report-table tbody tr:nth-child(even){

    background:#fafafa;

}

.summary{

    background:#fff3cd !important;

    font-weight:600;

}

</style>